import React, { Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'
import { aRecords, aUsers, aProjects, aTasks, aDates } from 'utils/aUtils'
import co from 'co'

import calcOvertime from './calcOvertime'

export default class OvertimeExportForm extends Component {
  constructor (props, context) {
    super(props, context)
    this.clearState = () => this.setState({ start: '', end: '', notice: '' })
    this.onStartChange = e => this.setState({ start: e.target.value })
    this.onEndChange = e => this.setState({ end: e.target.value })
    this.exportCSV = ::this.exportCSV
    this.handleSubmit = ::this.handleSubmit
  }

  state = {
    start: '',
    end: '',
    notice: '',
  };

  handleSubmit () {
    const { start, end } = this.state
    if (!misc.isValidDateString(start) || !misc.isValidDateString(end)) {
      this.setState({ notice: '錯誤日期格式' })
      return
    }
    this.setState({ notice: '' })

    const _this = this
    co(function*() {
      const users = yield aUsers.find()
      const userNames = misc.getDict(users, 'name')
      const projects = yield aProjects.find()
      const projectNames = misc.getDict(projects, 'name')
      const tasks = yield aTasks.find()
      const taskNames = misc.getDict(tasks, 'name')
      const dates = yield aDates.find()

      const allRecords = yield aRecords.findRange(misc.getDay(start), misc.getDay(end))
      _this.exportCSV(allRecords, userNames, projectNames, taskNames, dates, start, end)
      _this.clearState()
    }).catch(misc.onError)
  }

  exportCSV (records, userNames, projectNames, taskNames, dates, start, end) {
    const data = []
    records.forEach(record => {
      const { userId, projectId, taskId, oSegments = [], tSegments = [], dateString } = record

      oSegments.forEach(seg => {
        // ['Charles', '2016-8-1', '18:00', '18:30'],
        data.push([
          userNames[userId],
          dateString,
          projectNames[projectId],
          taskNames[taskId],
          misc.getTimeStr(seg.start),
          misc.getTimeStr(seg.end),
          '',
          '',
        ])
      })
      tSegments.forEach(seg => {
        data.push([
          userNames[userId],
          dateString,
          projectNames[projectId],
          taskNames[taskId],
          '',
          '',
          misc.getTimeStr(seg.start),
          misc.getTimeStr(seg.end),
        ])
      })
    })

    const calcData = data.map(record => [
      record[0], record[1], record[4], record[5], record[6], record[7],
    ])
    const { dailyData, reportData } = calcOvertime(calcData, dates, start, end)


    const BOM = '\uFEFF'

    const rawHead = ['姓名', '日期', '專案名稱', '內容代碼', '開始', '結束', '交通開始', '交通結束']
    const rawCSV = [rawHead, ...data]
        .map(row => row.join(',')).join('\n')

    misc.saveCSV(`${start}_${end}_加班明細表.csv`, `${BOM}${rawCSV}`)

    /*
      name: 'Charles',
      date: moment('2017-01-21'),
      type: 'dayoff',
      includeLimit: true,
      hours: 5,
      roundedHours: 8,
      traffic: 0,
      overtime: { o33: 0, o43: 2, o53: 6, o63: 0, o83: 0 },
      performance: { p33: 0, p43: 0, p53: 0, p63: 0, p83: 0 },
      note: '加班 5 小時以 8 小時計算',
    */
    const dailyDataHead = [
      '姓名',
      '日期',
      '日期別',
      '加班時數',
      '交通時數',
      '計算時數',
      '備註',
      'o33',
      'o43',
      'o53',
      'o63',
      'o83',
      'p33',
      'p43',
      'p53',
      'p63',
      'p83',
      '計入 46 上限',
    ]

    const typeNameMap = {
      workday: '工作日',
      dayoff: '休息日',
      leave: '例假日',
      holiday: '國定假日',
    }
    const dailyDataBody = dailyData.map(d => [
      d.name,
      d.date.format('YYYY-MM-DD'),
      typeNameMap[d.type],
      d.hours,
      d.traffic,
      d.roundedHours,
      d.note,
      d.overtime.o33,
      d.overtime.o43,
      d.overtime.o53,
      d.overtime.o63,
      d.overtime.o83,
      d.performance.p33,
      d.performance.p43,
      d.performance.p53,
      d.performance.p63,
      d.performance.p83,
      d.includeLimit,
    ])

    const dailyCSV = [dailyDataHead, ...dailyDataBody]
        .map(row => row.join(',')).join('\n')

    misc.saveCSV(`${start}_${end}_每日加班明細.csv`, `${BOM}${dailyCSV}`)

    /*
      name: 'Charles',
      start: moment('2017-01-01'),
      end: moment('2017-01-31'),
      hours: 10.5,
      traffic: 3,
      overtime: { o33: 0, o43: 4, o53: 6.5, o63: 0, o83: 0 },
      performance: { p33: 0, p43: 0, p53: 0, p63: 0, p83: 0 },
      factor: 4 * 4 / 3 + 6.5 * 5 / 3,
      overtimeFactor: 4 * 4 / 3 + 6.5 * 5 / 3,
      performanceFactor: 0,
      note: '2017-01-21 加班 5 小時以 8 小時計算',
    */
    const reportDataHead = [
      '姓名',
      '開始日期',
      '結束日期',
      '加班時數',
      '交通時數',
      '總加班倍數',
      '一般加班倍數',
      '績效加班倍數',
      '備註',
      'o33',
      'o43',
      'o53',
      'o63',
      'o83',
      'p33',
      'p43',
      'p53',
      'p63',
      'p83',
    ]
    const reportDataBody = Object.keys(reportData)
      .map(name => reportData[name])
      .map(d => [
        d.name,
        d.start.format('YYYY-MM-DD'),
        d.end.format('YYYY-MM-DD'),
        d.hours,
        d.traffic,
        d.factor,
        d.overtimeFactor,
        d.performanceFactor,
        d.note,
        d.overtime.o33,
        d.overtime.o43,
        d.overtime.o53,
        d.overtime.o63,
        d.overtime.o83,
        d.performance.p33,
        d.performance.p43,
        d.performance.p53,
        d.performance.p63,
        d.performance.p83,
      ])

    const reportCSV = [reportDataHead, ...reportDataBody]
        .map(row => row.join(',')).join('\n')

    misc.saveCSV(`${start}_${end}_加班統計表.csv`, `${BOM}${reportCSV}`)
  }

  render () {
    return (
      <div className={styles.recordExportForm}>
        <input
          className={styles.dateInput}
          placeholder="開始日期(xxxx-x-x)"
          value={this.state.start}
          onChange={this.onStartChange}
        />
        <input
          className={styles.dateInput}
          placeholder="結束日期(xxxx-x-x)"
          value={this.state.end}
          onChange={this.onEndChange}
        />
        <div className={styles.submit}>
          <input type="submit" value="匯出CSV" onClick={this.handleSubmit} />
        </div>
        <div className={styles.notice}>{this.state.notice}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/overtimeExportForm/index.jsx